module.exports = __webpack_public_path__ + "img/leaflink-logo-text-black.52eefc6a.svg";